import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ButtonGroup, IconButton } from 'rsuite';
import useMediaQuery from '@mui/material/useMediaQuery';
import { icons } from '@shared/static/icons';
import { theme } from '@utils/libs/theme';
import ThemeButton from '@shared/ui/buttons/ThemeButton';
import ThemeButtonIcon from '@shared/ui/buttons/ThemeButtonIcon';

export default function FilterButton({ onClick, filtersCount, resetFilters }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const hasFilters = filtersCount > 0;

  if (isMobile) {
    return (
      <ThemeButtonIcon
        appearance={hasFilters ? 'primary' : 'secondary'}
        icon="filter"
        onClick={onClick}
      />
    );
  }

  if (!hasFilters) {
    return (
      <ThemeButton
        appearance="secondary"
        startIcon="filter"
        onClick={onClick}
        block={false}
      >
        {t('filters')}
      </ThemeButton>
    );
  }

  return (
    <ButtonGroup>
      <ThemeButton onClick={onClick} block={false}>
        <div className="custom-badge-wrap">
          <div className="custom-badge">{filtersCount}</div>
        </div>
        {t('filters')}
      </ThemeButton>
      <IconButton
        appearance="primary"
        className="icon-btn icon-btn--border"
        icon={icons['close']}
        onClick={() => dispatch(resetFilters())}
      />
    </ButtonGroup>
  );
}
